const norm = (t = "") => String(t).replace(/_x000D_/g, "").replace(/\\r\\n|\\n/g, "\n").replace(/\\t/g, " ").replace(/\r\n/g, "\n")
  .replace(/&nbsp;|&#160;/gi, " ").replace(/&amp;/gi, "&").replace(/&quot;/gi, '"').replace(/&#0?39;|&apos;/gi, "'").replace(/&lt;/gi, "<").replace(/&gt;/gi, ">");

export function parseTracklist(text) {
  const lines = norm(text).split("\n").map((l) => l.replace(/^[\s•·*\-–]+/, "").trim()).filter(Boolean);
  const sides = [];
  const extra = [];
  let cur = null;
  let count = 0;
  for (const l of lines) {
    if (/^track\s*list(ing)?\s*:?$/i.test(l)) continue;
    const side = l.match(/^(side|disc|cd|lp)\s+([a-z0-9]+)\s*:?$/i);
    const track = l.match(/^track\s*(\d+)\s*[-–:.)]\s*(.+)$/i) || l.match(/^(\d{1,2})[.)]\s+(.+)$/);
    const lettered = !track && l.match(/^([A-H])(\d{1,2})\.?[\s\-–:]+(.+)$/);
    if (side) {
      const v = side[2].length === 1 ? side[2].toUpperCase() : `${side[2][0].toUpperCase()}${side[2].slice(1).toLowerCase()}`;
      cur = { name: `${side[1][0].toUpperCase()}${side[1].slice(1).toLowerCase()} ${v}`, tracks: [] };
      sides.push(cur);
    } else if (track || lettered) {
      if (lettered && cur?.letter !== lettered[1] && !cur?.explicit) {
        cur = { name: `Side ${lettered[1]}`, letter: lettered[1], tracks: [] };
        sides.push(cur);
      }
      if (!cur) {
        cur = { name: "", tracks: [] };
        sides.push(cur);
      }
      cur.tracks.push(track ? { n: track[1], title: track[2] } : { n: cur.explicit ? `${lettered[1]}${lettered[2]}` : lettered[2], title: lettered[3] });
      count += 1;
    } else extra.push(l);
    if (side) cur.explicit = true;
  }
  return count ? { sides: sides.filter((s) => s.tracks.length), extra } : null;
}

export const Paragraphs = ({ text, testid }) => (
  <div className="space-y-3 text-sm text-[#444] leading-relaxed" data-testid={testid}>
    {norm(text).split(/\n\s*\n/).filter((b) => b.trim()).map((b, i) => <p key={i} className="whitespace-pre-line">{b.trim()}</p>)}
  </div>
);

export function splitContent(p) {
  const parsedT = parseTracklist(p.tracklist);
  const parsedD = parseTracklist(p.description);
  const list = parsedT || parsedD;
  return {
    list,
    count: list ? list.sides.reduce((s, x) => s + x.tracks.length, 0) : 0,
    plainDesc: parsedD ? parsedD.extra.join("\n") : p.description || "",
    plainTracks: !parsedT && p.tracklist ? p.tracklist : "",
  };
}

const Disc = () => (
  <span className="w-3.5 h-3.5 rounded-full bg-[#111] grid place-items-center shrink-0"><span className="w-1.5 h-1.5 rounded-full bg-red" /></span>
);

export function TracklistSection({ list, count, sku }) {
  return (
    <section className="mt-20" data-testid="product-tracklist">
      <div className="flex items-end justify-between border-b-2 border-black pb-3 mb-6">
        <h2 className="font-head font-extrabold text-2xl sm:text-[28px] tracking-tight">Tracklist</h2>
        <span className="label-caps text-[10px] text-[#888]" data-testid="tracklist-count">{count} tracks · {sku}</span>
      </div>
      <div className="grid md:grid-cols-2 gap-x-12 gap-y-10">
        {list.sides.map((s, si) => (
          <div key={si} data-testid={`tracklist-side-${si}`}>
            <div className="flex items-center gap-2.5 pb-2.5 border-b border-[#ddd]">
              <Disc />
              <p className="font-head font-bold text-[15px]" data-testid={`tracklist-side-name-${si}`}>{s.name || "Tracks"}</p>
              <span className="text-[11px] text-[#999] font-arial">{s.tracks.length} tracks</span>
            </div>
            <ol>
              {s.tracks.map((t, ti) => (
                <li key={ti} className="flex gap-4 py-2.5 border-b border-[#ececec] text-sm" data-testid={`tracklist-track-${si}-${ti}`}>
                  <span className="font-arial text-[#9a9a9a] min-w-[1.5rem] text-right shrink-0">{t.n}</span>
                  <span className="text-[#222]">{t.title}</span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
}


